@if ({
  row: columnData | async,
  adata: additionData | async
  }; as $) {
  <button pButton pRipple type="button" icon="fa fa-angle-down" [label]="'common.BUTTONS.BTN_ACTIONS' | translate"
    iconPos="right" class="text-sm text-600 p-button-outlined p-button-secondary border-400 p-2"
    [disabled]="!hasVisibleActions($)"
  (click)="hasVisibleActions($) ? action.toggle($event) : null" aria-label="actions-button"></button>
  <p-popover #action styleClass="overflow-hidden text-sm w-10rem -ml-5" aria-label="actions-menu">
    <ng-template #content>
      <ul #listContainer class="list-none -m-4 py-2 px-0 text-xs text-600" role="menu">
        @if ($.adata?.includes('edit')) {
          <li (click)=" executeAction('edit',$.row,action) "
            class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" role="menuitem" aria-label="edit-action">
            <i class="fa fa-pencil text-xs mr-2" aria-hidden="true"></i> {{ 'ADMIN.COMMON.EDIT' | translate }}
          </li>
        }
        @if ($.adata?.includes('status')) {
          <li (click)="executeAction('status',$.row,action) "
            class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" role="menuitem" [attr.aria-label]="'status-action-' + (isActive($.row) ? 'inactive' : 'active')">
            <i class="text-xs mr-2" [ngClass]="isActive($.row) ? 'fa fa-eye-slash' : 'fa fa-eye' " aria-hidden="true"></i>
            {{ 'Shared.TASK.TASK-CREATE.MARK' | translate }} {{isActive($.row)? 'In-active': 'Active'}}
          </li>
        }
        @if ($.adata?.includes('tenantstatus') && !isPresalesTenant($.row)) {
          <li (click)="executeAction('tenantstatus',$.row,action) "
            class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" role="menuitem" [attr.aria-label]="'status-action-' + (showActiveTenant($.row) ? 'inactive' : 'active')">
            <i class="text-xs mr-2" [ngClass]="showActiveTenant($.row) ? 'fa fa-eye-slash' : 'fa fa-eye' " aria-hidden="true"></i>
            {{ 'Shared.TASK.TASK-CREATE.MARK' | translate }} {{showActiveTenant($.row) ? 'In-active': 'Active'}}
          </li>
        }
        @if ( $.adata?.includes('delete')) {
          <li (click)="executeAction('delete',$.row,action)"
            class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" role="menuitem" aria-label="delete-action">
            <i class="fa fa-trash-alt text-xs mr-2" aria-hidden="true"></i> {{ 'ADMIN.COMMON.DELETE' | translate }}
          </li>
        }
        @if ( $.adata?.includes('print')) {
          <li (click)=" executeAction('print',$.row,action)"
            class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" role="menuitem" aria-label="print-action">
            <i class="fa fa-print mr-2" aria-hidden="true"></i> {{ 'ADMIN.COMMON.PRINT' | translate }}
          </li>
        }
        @if ( $.adata?.includes('sendemail')) {
          <li (click)=" executeAction('sendemail',$.row,action)"
            class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" role="menuitem" aria-label="send-email-action">
            <i class=" fa fa-envelope font-light mr-2" aria-hidden="true"></i> {{ 'ADMIN.COMMON.SENDEMAIL' | translate }}
          </li>
        }
        @if ( $.adata?.includes('sendwhatsapp')) {
          <li (click)=" executeAction('sendwhatsapp',$.row,action)"
            class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" role="menuitem" aria-label="send-whatsapp-action">
            <i class="fab fa-whatsapp mr-2" aria-hidden="true"></i> {{ 'ADMIN.COMMON.SEND_WHATSAPP' | translate }}
          </li>
        }
        @if ( $.adata?.includes('sendmobilenotification')) {
          <li (click)="executeAction('sendmobilenotification',$.row,action)"
            class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" role="menuitem" aria-label="send-push-notification-action">
            <i class="fab fa-bell mr-2" aria-hidden="true"></i> {{ 'ADMIN.COMMON.SEND_PUSH_NOTIFICATION' | translate }}
          </li>
        }
        @if ( $.adata?.includes('void') && !isStatusVoid($.row)) {
          <li
            (click)=" executeAction('void',$.row,action)"
            class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" role="menuitem" aria-label="void-action">
            <i class="fa fa-ban mr-2" aria-hidden="true"></i> {{ 'ADMIN.COMMON.VOID' | translate }}
          </li>
        }
        @if ( $.adata?.includes('collectdues') &&  $.row.total_balance_due_in_minor_currency > 0) {
          <li
            (click)="executeAction('collectdues',$.row,action)"
            class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" role="menuitem" aria-label="collect-dues-action">
            <i class="fa fa-money-bill mr-2" aria-hidden="true"></i>
            {{ 'ADMIN.COMMON.COLLECTDUES' | translate }}
          </li>
        }
        @if ( $.adata?.includes('refundandsalesreturn') && (showSalesReturn | async) && !isStatusVoid($.row)) {
          <li
            (click)="executeAction('refundandsalesreturn',$.row,action)"
            class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" role="menuitem" aria-label="refund-sales-return-action">
            <i class="fa fa-rotate-left mr-2" aria-hidden="true"></i>
            {{ 'ADMIN.COMMON.SALESRETURN' | translate }}
          </li>
        }
        @if ( $.adata.includes('changebillowner') ) {
          <li
            [ngClass]="hasAdminBilling ? '':'opacity-40 pointer-events-none'"
            (click)=" executeAction('changebillowner',$.row,action)"
            class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" role="menuitem" aria-label="change-bill-owner-action">
            <i class="fa fa-user-edit mr-2" aria-hidden="true"></i> {{ 'ADMIN.COMMON.CHANGE_SALES_REP' | translate }}
          </li>
        }
        @if ( $.adata.includes('cancelTransfer') ) {
          <li
            [ngClass]="hasAdminBilling ? '':'opacity-40 pointer-events-none'"
            (click)=" executeAction('cancelTransfer',$.row,action)"
            class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" role="menuitem" aria-label="cancel-transfer-action">
            <i class="fa fa-minus-circle mr-2" aria-hidden="true"></i> {{ 'ADMIN.COMMON.CANCEL_TRANSFER' | translate }}
          </li>
        }
        @if ( $.adata.includes('startTransfer')) {
          <li
            [ngClass]="hasAdminBilling ? '':'opacity-40 pointer-events-none'"
            (click)=" executeAction('startTransfer',$.row,action)"
            class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" role="menuitem" aria-label="start-transfer-action">
            <i class="fa fa-arrows-h mr-2" aria-hidden="true"></i> {{ 'ADMIN.COMMON.START_TRANSFER' | translate }}
          </li>
        }
        @if ( $.adata.includes('salesreturnvoid')) {
          <li
            (click)=" executeAction('salesreturnvoid',$.row,action)"
            class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" role="menuitem" aria-label="sales-return-void-action">
            <i class="fa fa-ban mr-2" aria-hidden="true"></i> {{ 'ADMIN.COMMON.VOID' | translate }}
          </li>
        }
        @if ( $.adata.includes('refundvoid') && !isRefundStatusVoid($.row)) {
          <li
            (click)=" executeAction('refundvoid',$.row,action)"
            [ngClass]="hasAdminBilling ? '':'opacity-40 pointer-events-none'"
            class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" role="menuitem" aria-label="refund-void-action">
            <i class="fa fa-ban mr-2" aria-hidden="true"></i> {{ 'ADMIN.COMMON.VOID' | translate }}
          </li>
        }
        @if ( $.adata.includes('refund') && (showRefund | async)  && showRefundOption($.row)) {
          <li
            (click)="executeAction('refund',$.row,action)"
            class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center"
            [ngClass]="hasAdminBilling ? '':'opacity-40 pointer-events-none'" role="menuitem" aria-label="refund-action">
            <i class="fa fa-wallet mr-2" aria-hidden="true"></i> {{ 'ADMIN.COMMON.REFUND' | translate }}
          </li>
        }
        @if ($.adata.includes('selfsignup') && isActive($.row)) {
          <li
            (click)="executeAction('selfsignup',$.row,action)"
            class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" role="menuitem" aria-label="self-signup-action">
            <i class="fa fa-qrcode text-xs mr-2" aria-hidden="true"></i> {{ 'ADMIN.COMMON.SELF_SIGN_UP' | translate }}
          </li>
        }
        @if ($.adata.includes('balanceclear') && isStatusPartialOrOpen($.row)) {
          <li
            (click)="executeAction('balanceclear',$.row,action)"
            class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" role="menuitem" aria-label="balance-clear-action">
            <i class="fa fa-qrcode text-xs mr-2" aria-hidden="true"></i> {{ 'ADMIN.COMMON.DUE_LINK' | translate }}
          </li>
        }
        @if ($.adata.includes('changedate') && isPresales($.row)) {
          <li
            class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center"
            (click)="executeAction('changedate',$.row,action)" role="menuitem" aria-label="change-date-action">
            <i class="fa fa-calendar-alt text-xs mr-2" aria-hidden="true"></i>{{ 'ADMIN.COMMON.CHANGE_OPERATIONAL_DATE' | translate }}
          </li>
        }
        @if ($.adata.includes('writeoff') && showWriteOff.value) {
          <li [ngClass]="hasBalanceAmount($.row) && !isStatusVoid($.row) ? '' : 'opacity-40 pointer-events-none'"
            class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center"
            (click)="executeAction('writeoff',$.row,action)" role="menuitem" aria-label="writeoff-action">
            <i class="fa fa-file-excel text-xs mr-2" aria-hidden="true"></i>{{ 'ADMIN.COMMON.WRITEOFF' | translate }}
          </li>
        }
        @if ($.adata?.includes('duplicate')) {
          <li (click)=" executeAction('duplicate',$.row,action) "
            class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" role="menuitem" aria-label="duplicate-action">
            <i class="fa fa-copy text-xs mr-2" aria-hidden="true"></i> {{ 'ADMIN.COMMON.DUPLICATE' | translate }}
          </li>
        }
        @if ($.adata?.includes('convertContact')) {
          <li (click)=" executeAction('convertContact',$.row,action) "
            class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" role="menuitem" aria-label="convert-action">
            <i class="fa fa-exchange-alt text-xs mr-2" aria-hidden="true"></i> {{ 'ADMIN.COMMON.CONVERTCONTACT' | translate }}
          </li>
        }
        @if ($.adata?.includes('stop_campaign') && showStopCampaign($.row)) {
          <li
            (click)="executeAction('stop_campaign',$.row,action)"
            class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" role="menuitem" aria-label="stop-campaign-action">
            <i class="fa fa-stop-circle text-xs mr-2" aria-hidden="true"></i> {{ 'ADMIN.COMMON.STOP_CAMPAIGN' | translate }}
          </li>
        }
        @if ($.adata?.includes('void_campaign') && showVoidCampaign($.row)) {
          <li
            (click)="executeAction('void_campaign',$.row,action)"
            class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" role="menuitem" aria-label="void-campaign-action">
            <i class="fa fa-ban text-xs mr-2" aria-hidden="true"></i> {{ 'ADMIN.COMMON.VOID_CAMPAIGN' | translate }}
          </li>
        }
        @if ($.adata?.includes('view')) {
          <li (click)=" executeAction('view',$.row,action) "
            class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" role="menuitem" aria-label="view-action">
            <i class="fa fa-eye text-xs mr-2" aria-hidden="true"></i> {{ 'ADMIN.COMMON.VIEW' | translate }}
          </li>
        }
        @if ($.adata?.includes('mark_fulfilled') && $.row.fulfilled === false) {
          <li (click)="executeAction('mark_fulfilled',$.row,action) "
            class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" role="menuitem" aria-label="view-action">
            <i class="fa fa-check text-xs mr-2" aria-hidden="true"></i> {{ 'ADMIN.COMMON.MARK_FULFILLED' | translate }}
          </li>
        }
        @if ( $.adata?.includes('cancel') && ($.row.status === 'Queued' || $.row.status === 'InProgress') ) {
          <li
            [ngClass]="hasAdminBilling ? '':'opacity-40 pointer-events-none'"
            (click)="executeAction('cancel',$.row,action)"
            class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" role="menuitem" aria-label="cancel-transfer-action">
            <i class="fa fa-minus-circle mr-2" aria-hidden="true"></i> {{ 'ADMIN.COMMON.CANCEL' | translate }}
          </li>
        }
        @if ( $.adata?.includes('cancelrecurringclass')) {
          <li
            [ngClass]="CanAdminClass ? '':'opacity-40 pointer-events-none'"
            (click)="executeAction('cancelrecurringclass',$.row,action)"
            class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" role="menuitem" aria-label="cancel-transfer-action">
            <i class="fa fa-minus-circle mr-2" aria-hidden="true"></i> {{ 'ADMIN.COMMON.CANCEL' | translate }}
          </li>
        }
        @if ( $.adata?.includes('deleterecurringclass')) {
          <li
            [ngClass]="CanAdminClass ? '':'opacity-40 pointer-events-none'"
            (click)="executeAction('deleterecurringclass',$.row,action)"
            class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" role="menuitem" aria-label="delete-recurring-class-action">
            <i class="fa fa-trash-alt mr-2" aria-hidden="true"></i> {{ 'ADMIN.COMMON.DELETE' | translate }}
          </li>
        }
        @if ($.adata?.includes('edit_freeze') && ShowEditOption($.row) && ShowEditOptionInV1ForNonContract($.row)) {
          <li (click)="executeAction('edit_freeze',$.row,action)"
            class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" [attr.aria-label]="'edit freeze '" [attr.data-testid]="'edit-freeze-'">
            <i class="fa fa-pencil text-xs mr-2"></i>
            {{ 'FREEZE.FREEZE_LIST.EDIT' | translate }}
          </li>
        }
        @if ($.adata?.includes('cancel_freeze') && ShowCancelOption($.row)) {
          <li (click)="executeAction('cancel_freeze',$.row,action)"
            class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" [attr.aria-label]="'void freeze'" [attr.data-testid]="'void-freeze-'">
            <i class="fa fa-ban text-xs mr-2"></i>
            {{ 'FREEZE.FREEZE_LIST.VOID' | translate }}
          </li>
        }
        @if ($.adata?.includes('stop_freeze') && ShowStopOption($.row) && ShowEditOptionInV1ForNonContract($.row)) {
          <li (click)="executeAction('stop_freeze',$.row,action)"
            class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" [attr.aria-label]="'stop freeze '" [attr.data-testid]="'stop-freeze-'">
            <i class="fa fa-minus-circle text-xs mr-2"></i>
            {{ 'FREEZE.FREEZE_LIST.STOP' | translate }}
          </li>
        }
        @if ($.adata?.includes('assign_staff')) {
          <li (click)="executeAction('assign_staff',$.row,action)"
            class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" [attr.aria-label]="'stop freeze '" [attr.data-testid]="'stop-freeze-'">
            <i class="fa fa-user-plus text-xs mr-2"></i>
            {{ 'COMMISSION_MANAGEMENT.COMMON.ASSIGN_STAFF' | translate }}
          </li>
        }

        @if ($.adata?.includes('campaign_status') && isStatusActiveOrInActiveForCampaign($.row)) {  
        <li (click)="executeAction('campaign_status',$.row,action) "
                    class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" role="menuitem" [attr.aria-label]="'status-action-' + (isActive($.row) ? 'inactive' : 'active')">
                    <i class="text-xs mr-2" [ngClass]="isActive($.row) ? 'fa fa-eye-slash' : 'fa fa-eye' " aria-hidden="true"></i>
                    {{ 'Shared.TASK.TASK-CREATE.MARK' | translate }} {{isActive($.row)? 'In-active': 'Active'}}
                </li>
        }

        @if ($.adata?.includes('create_charge')) {  
          <li (click)="executeAction('create_charge',$.row,action) "
                      class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" role="menuitem" aria-label="create-charge-action">
                      <i class="fa fa-plus-circle text-xs mr-2" aria-hidden="true"></i>
                      {{ 'ADMIN.CHARGE.CREATE_CHARGE' | translate }}
                  </li>
          }
      </ul>
    </ng-template>
  </p-popover>
}